import supervisor from './supervisor';
import quotaArticle from './quotaArticle';
import customer from './customer';
import city from './city';

export default {
  supervisor,
  quotaArticle,
  customer,
  city
}
